import { render, staticRenderFns } from "./TopicTable.vue?vue&type=template&id=0228dec7&"
import script from "./TopicTable.vue?vue&type=script&lang=js&"
export * from "./TopicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports